import { Component } from "react"
import { fields } from "../../../../fields"

import { Container, Divider, Header, Icon, Form, FormGroup, FormField, Select, Input, TextArea } from 'semantic-ui-react'

const departmentName = 'Client Profile'

const options = [
    { key: 'low', text: 'Low', value: 'Low' },
    { key: 'average', text: 'Average', value: 'Average' },
    { key: 'high', text: 'High', value: 'High' },
    { key: 'not-sure', text: 'Not sure', value: 'Not sure' },
]

const yesNoOptions = [
    { key: 'yes', text: 'Yes', value: 'Yes' },
    { key: 'no', text: 'No', value: 'No' },
    { key: 'not-sure', text: 'Not sure', value: 'Not sure' },
]

const langaugeOptions = [
    { key: 'mandarin', text: 'Mandarin', value: 'Mandarin' },
    { key: 'english', text: 'English', value: 'English' },
    { key: 'not-sure', text: 'Not sure', value: 'Not sure' },
]

const qualityOptions = [
    { key: 'average', text: 'Average', value: 'Average' },
    { key: 'high', text: 'High', value: 'High' },
    { key: 'very-high', text: 'Very High', value: 'Very High' },
    { key: 'not-sure', text: 'Not sure', value: 'Not sure' },
]

class ClientProfile extends Component {
    state = {}

    componentDidMount() {
        var savedDict = {}
        if (this.props.savedDict) {
            savedDict = this.props.savedDict
        } else {
            return
        }
        this.setState({
            name1: savedDict.name1,
            languagePreference1: savedDict.languagePreference1,
            knowledgeIT1: savedDict.knowledgeIT1,
            knowledgeFinanceAccounting1: savedDict.knowledgeFinanceAccounting1,
            knowledgeFMDContact1: savedDict.knowledgeFMDContact1,
            clientCharacteristicsByStaff1: savedDict.clientCharacteristicsByStaff1,
            otherCharacteristics1: savedDict.otherCharacteristics1,

            name2: savedDict.name2,
            languagePreference2: savedDict.languagePreference2,
            knowledgeIT2: savedDict.knowledgeIT2,
            knowledgeFinanceAccounting2: savedDict.knowledgeFinanceAccounting2,
            knowledgeFMDContact2: savedDict.knowledgeFMDContact2,
            clientCharacteristicsByStaff2: savedDict.clientCharacteristicsByStaff2,
            otherCharacteristics2: savedDict.otherCharacteristics2,

            internalAccountingStaff: savedDict.internalAccountingStaff,

            priceSensitivity: savedDict.priceSensitivity,
            qualityOfWork: savedDict.qualityOfWork,
            clientExpectationsByStaff: savedDict.clientExpectationsByStaff,
            otherExpectations: savedDict.otherExpectations,
            feedbackReceived: savedDict.feedbackReceived,
        })
    }

    handleChangeField = e => {
        if (this.props.viewOnly) {
            if (this.state[e.target.name] == null) {
                this.setState({ [e.target.name]: ""})
            }
            return
        }
        const { name, value } = e.target
        if (!getWritePermissionForField(name, this.props.permissions) && this.state[e.target.name] == null) {
            this.setState({ [e.target.name]: ""})
            return
        }   
        else if (!getWritePermissionForField(name, this.props.permissions)) return
        this.setState({ [name]: value }, () =>
            this.props.onStateChange(this.state)
        )
    }
    handleChangeDropDown = (e, data) => {
        if (this.props.viewOnly) return
        const { name, value } = data
        if (!getWritePermissionForField(name, this.props.permissions)) return
        this.setState({ [name]: value }, () =>
            this.props.onStateChange(this.state)
        )
    }

    getFieldStyle(name) {
        if (!getReadPermissionForField(name, this.props.permissions)) {
            return { visibility: 'hidden' }
        }
        return { visibility: 'visible' }
    }

    render() {
        const { name1, languagePreference1, knowledgeIT1, knowledgeFinanceAccounting1, knowledgeFMDContact1, clientCharacteristicsByStaff1, otherCharacteristics1, name2, languagePreference2, knowledgeIT2, knowledgeFinanceAccounting2, knowledgeFMDContact2, 
            clientCharacteristicsByStaff2, otherCharacteristics2, internalAccountingStaff, priceSensitivity, qualityOfWork, otherExpectations, feedbackReceived, clientExpectationsByStaff } = this.state
        return (
            <Container>
                <Form>
                    <Divider horizontal><Header as='h4'><Icon name='smile outline' />Client Characteristics</Header></Divider>
                    <FormField style={this.getFieldStyle('internalAccountingStaff')} control={Select} label='Internal Accounting Staff' name='internalAccountingStaff' value={internalAccountingStaff} defaultValue={internalAccountingStaff} options={yesNoOptions} 
                        placeholder='Select one' onChange={this.handleChangeDropDown}/>
                    <h3>Client 1</h3>
                    <FormField style={this.getFieldStyle('name1')} control={Input} label='Name of Client' name='name1' value={name1} onChange={this.handleChangeField}/>
                    <FormGroup widths='equal'>
                        <FormField style={this.getFieldStyle('languagePreference1')} control={Select} label='Language Preference' name='languagePreference1' value={languagePreference1} defaultValue={languagePreference1} options={langaugeOptions} placeholder='Select one'  
                            onChange={this.handleChangeDropDown}/>
                        <FormField style={this.getFieldStyle('knowledgeIT1')} control={Select} label='IT Knowledge ' name='knowledgeIT1' value={knowledgeIT1} defaultValue={knowledgeIT1} options={options} placeholder='Select one' 
                            onChange={this.handleChangeDropDown}/>
                        <FormField style={this.getFieldStyle('knowledgeFinanceAccounting1')} control={Select} label='Knowledge in Finance / Accounting ' name='knowledgeFinanceAccounting1' value={knowledgeFinanceAccounting1} defaultValue={knowledgeFinanceAccounting1} 
                            options={options} placeholder='Select one' onChange={this.handleChangeDropDown}/>
                    </FormGroup>
                    <FormField style={this.getFieldStyle('knowledgeFMDContact1')} control={Select} label='Know Our WhatsApp Number and Which Number ' name='knowledgeFMDContact1' value={knowledgeFMDContact1} defaultValue={knowledgeFMDContact1} options={yesNoOptions} 
                        placeholder='Select one' onChange={this.handleChangeDropDown}/>
                    <FormField style={this.getFieldStyle('clientCharacteristicsByStaff1')} control={TextArea} rows='5' label='Information Provided by Staff ' name='clientCharacteristicsByStaff1' value={clientCharacteristicsByStaff1} onChange={this.handleChangeField}/>
                    <FormField style={this.getFieldStyle('otherCharacteristics1')} control={TextArea} rows='5' label='Others ' name='otherCharacteristics1' value={otherCharacteristics1} onChange={this.handleChangeField}/>
                    <br/><h3>Client 2</h3>
                    <FormField style={this.getFieldStyle('name2')} control={Input} label='Name of Client ' name='name2' value={name2} onChange={this.handleChangeField}/>
                    <FormGroup widths='equal'>
                        <FormField style={this.getFieldStyle('languagePreference2')} control={Select} label='Language Preference ' name='languagePreference2' value={languagePreference2} defaultValue={languagePreference2} options={langaugeOptions} placeholder='Select one'  
                            onChange={this.handleChangeDropDown}/>
                        <FormField style={this.getFieldStyle('knowledgeIT2')} control={Select} label='IT Knowledge ' name='knowledgeIT2' value={knowledgeIT2} defaultValue={knowledgeIT2} options={options} placeholder='Select one' 
                            onChange={this.handleChangeDropDown}/>
                        <FormField style={this.getFieldStyle('knowledgeFinanceAccounting2')} control={Select} label='Knowledge in Finance / Accounting ' name='knowledgeFinanceAccounting2' value={knowledgeFinanceAccounting2} defaultValue={knowledgeFinanceAccounting2} 
                            options={options} placeholder='Select one' onChange={this.handleChangeDropDown}/>
                    </FormGroup>
                    <FormField style={this.getFieldStyle('knowledgeFMDContact2')} control={Select} label='Know Our WhatsApp Number and Which Number ' name='knowledgeFMDContact2' value={knowledgeFMDContact2} defaultValue={knowledgeFMDContact2} options={yesNoOptions} 
                        placeholder='Select one' onChange={this.handleChangeDropDown}/>
                    <FormField style={this.getFieldStyle('clientCharacteristicsByStaff2')} control={TextArea} rows='5' label='Information Provided by Staff ' name='clientCharacteristicsByStaff2' value={clientCharacteristicsByStaff2} onChange={this.handleChangeField}/>
                    <FormField style={this.getFieldStyle('otherCharacteristics2')} control={TextArea} rows='5' label='Others ' name='otherCharacteristics2' value={otherCharacteristics2} onChange={this.handleChangeField}/>
                    <br/><Divider horizontal style={{ marginTop: 40, marginBottom: 25 }}><Header as='h4'><Icon name='star' />Client Expectations</Header></Divider>
                    <FormGroup widths='equal'>
                        <FormField style={this.getFieldStyle('priceSensitivity')} control={Select} label='Price Sensitivity' name='priceSensitivity' value={priceSensitivity} defaultValue={priceSensitivity} options={options} placeholder='Select one' 
                            onChange={this.handleChangeDropDown}/>
                        <FormField style={this.getFieldStyle('qualityOfWork')} control={Select} label='Quality of Work' name='qualityOfWork' value={qualityOfWork} defaultValue={qualityOfWork} options={qualityOptions} placeholder='Select one' 
                            onChange={this.handleChangeDropDown}/>
                    </FormGroup>
                    <FormField style={this.getFieldStyle('clientExpectationsByStaff')} control={TextArea} rows='5' label='Information Provided by Staff:' name='clientExpectationsByStaff' value={clientExpectationsByStaff} onChange={this.handleChangeField}/>
                    <FormField style={this.getFieldStyle('otherExpectations')} control={TextArea} rows='5' label='Others' name='otherExpectations' value={otherExpectations} onChange={this.handleChangeField}/>
                    <FormField style={this.getFieldStyle('feedbackReceived')} control={TextArea} rows='5' label='Feedback Received' name='feedbackReceived' value={feedbackReceived} onChange={this.handleChangeField}/>
                </Form>
            </Container>
        )
    }
}

function getWritePermissionForField(fieldName, permissions) {
    var key = ""
    for (let field of fields) {
        if (field.field === fieldName && field.departmentName === departmentName) {
            key = field.key
        }
    }
    for (let permission of permissions) {
        if (permission.key === key) {
            if (permission.write === false) {
            }
            return permission.write
        }
    }
}

function getReadPermissionForField(fieldName, permissions) {
    var key = ""
    for (let field of fields) {
        if (field.field === fieldName && field.departmentName === departmentName) {
            key = field.key
        }
    }
    for (let permission of permissions) {
        if (permission.key === key) {
            return permission.read
        }
    }
}

export default ClientProfile